var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85052 1.37544C9.45966 0.743352 8.54034 0.743351 8.14948 1.37544L6.06682 4.74342C5.92794 4.96801 5.70587 5.12856 5.44906 5.19002L1.5921 6.11311C0.864696 6.2872 0.578874 7.169 1.06584 7.73671L3.63215 10.7285C3.80513 10.9302 3.89075 11.1924 3.87011 11.4573L3.5644 15.3812C3.50656 16.1237 4.25158 16.6666 4.94068 16.3841L8.6207 14.8756C8.86375 14.7759 9.13625 14.7759 9.3793 14.8756L13.0593 16.3841C13.7484 16.6666 14.4934 16.1237 14.4356 15.3812L14.1299 11.4573C14.1093 11.1924 14.1949 10.9302 14.3678 10.7285L16.9342 7.73671C17.4211 7.169 17.1353 6.2872 16.4079 6.11311L12.5509 5.19002C12.2941 5.12856 12.0721 4.96802 11.9332 4.74342L9.85052 1.37544Z",
    fill: "url(#paint0_linear_10257_6612)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10257_6612",
    x1: 8.99795,
    y1: -0.0909218,
    x2: 8.99795,
    y2: 17.0651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAB17"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a862ae8ba9f0e69cc5058c5f3b003672.svg";
export { ForwardRef as ReactComponent };